import TrebbleTooltip from '../../../../common/TrebbleTooltip';

interface FieldContainerProps {
    label: string;
    children: React.ReactNode;
    className?: string;
    description?: string;
    direction?: 'row' | 'col';
    labelClassName?: string;
    showInfoIcon?: boolean;
}

export const FieldContainer: React.FC<FieldContainerProps> = ({ 
    label, 
    children, 
    className = '', 
    description,
    direction = 'col',
    labelClassName = '',
    showInfoIcon = true
}) => {
    const containerClassName = direction === 'row' 
        ? `flex flex-row items-center gap-4 py-2 w-full box-border ${className}`
        : `flex flex-col py-2 box-border ${className}`;

    const labelContainerClassName = direction === 'row'
        ? `${labelClassName}`
        : `mb-1 ${labelClassName}`;

    const childrenContainerClassName = direction === 'row' 
        ? 'flex justify-end flex-1' 
        : 'w-full';

    return (
        <div className={containerClassName}>
            <div className={labelContainerClassName}>
                <div className="flex items-center gap-2">
                    {label}
                    {showInfoIcon && description && (
                        <TrebbleTooltip title={description}>
                            <i className="pe-7s-info opacity-50"></i>
                        </TrebbleTooltip>
                    )}
                </div>
                {!showInfoIcon && description && direction === 'col' && (
                    <div className="opacity-50 text-sm pb-1">{description}</div>
                )}
            </div>
            <div className={childrenContainerClassName}>
                {children}
            </div>
        </div>
    );
}; 